import { USER_FIELDS } from "src/business.InterfaceLayer/store/entities/user.entity/redux/fields";
import { IUser } from "src/business.InterfaceLayer/store/entities/user.entity/redux/type";

const getFullName = (user: IUser): string => {
	return (
		`${user?.[USER_FIELDS.LAST_NAME] || ""} ${user?.[USER_FIELDS.NAME] || ""} ${
			user?.[USER_FIELDS.MIDDLE_NAME] || ""
		}`.trim() || "-"
	);
};

export default getFullName;
